var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import { useFloating, useClick, useInteractions, useFloatingNodeId, FloatingPortal, FloatingFocusManager, FloatingOverlay, size, } from '@floating-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGrid } from '@fortawesome/pro-solid-svg-icons/faGrid';
import style from './MobileMenuButton.module.scss';
import { MobileMenuList } from './MobileMenuList';
export function MobileMenuButton() {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var nodeId = useFloatingNodeId();
    var _b = useFloating({
        nodeId: nodeId,
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            size({
                apply: function (_a) {
                    var availableWidth = _a.availableWidth, elements = _a.elements;
                    Object.assign(elements.floating.style, {
                        width: availableWidth,
                        height: '100vh',
                    });
                },
            }),
        ],
    }), refs = _b.refs, context = _b.context;
    var click = useClick(context);
    var _c = useInteractions([click]), getReferenceProps = _c.getReferenceProps, getFloatingProps = _c.getFloatingProps;
    return (_jsxs("div", { children: [_jsx("button", __assign({ type: "button", ref: refs.setReference }, getReferenceProps(), { className: style.button }, { children: _jsx(FontAwesomeIcon, { className: style.menuIcon, icon: faGrid }) })), _jsx(FloatingPortal, { children: isOpen && (_jsx(FloatingOverlay, __assign({ lockScroll: true, style: { zIndex: 1090 } }, { children: _jsx(FloatingFocusManager, __assign({ context: context }, { children: _jsx("div", __assign({ className: style.overlay, ref: refs.setFloating }, getFloatingProps(), { children: _jsx(MobileMenuList, { onDismissed: function () { return setIsOpen(false); } }) })) })) }))) })] }));
}
